export default "__VITE_ASSET__Czb1rBjQ__"